import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'
export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let employer = useDataValue({
    context: 'tx_category_insured',
    viewPath: props.viewPath,
    path: 'insured.insurance_subscription.employer_id',
  })
  return function onClick(action) {
    switch (action) {
      case 'EDIT':
        if (employer !== '') {
          return editEmployer()
        }
        return
      case 'ADD':
        return addEmployer()
      default:
        return
    }
  }

  function editEmployer() {
    setFlowTo(normalizePath(props.viewPath, './Edit/Content'))
  }
  function addEmployer() {
    setFlowTo(normalizePath(props.viewPath, './Create/Content'))
  }
}
